import { type ClassValue as CLSXClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export type ClassValue = CLSXClassValue
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
